<template>
  <!-- 헤더 영역 -->
  <header>
    <div class="inner">
       <!-- 로고 영역 -->
      <h1 id="logo">
        <a @click.prevent="move()">
          <img :src="require('@/assets/images/logo.png')" alt="대구로" />
          <em>고객지원</em>
        </a>
      </h1>
      <!-- 모바일 검색창 -->
      <div
        class="searchWrap"
        :style="{ display: !isMobile ? 'none' : 'block' }"
      >
        <button type="button" class="btnSearch">통합검색 버튼</button>
        <form class="search mobile" @submit.prevent="search">
          <input
            type="text"
            v-model="keyword"
            placeholder="키워드를 입력하여 검색해보세요."
          />
          <button type="submit">검색</button>
        </form>
      </div>
      <!-- 모바일 메뉴 버튼 -->
      <button type="button" class="btnMenu">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>
  </header>
  <!-- 메인 컨테이너 -->
  <div class="container">
    <div class="inner">
      <ul id="menu">
        <li
          v-for="(row, idx) in serviceUserData"
          :key="idx"
          :class="{ current: serviceCode === row.serviceCode }"
          @mouseenter="handleMouseEnter(idx)"
          @mouseleave="handleMouseLeave(idx)"
        >
          <a
            class="menuIco"
            :rel="'menuCon' + (idx + 1)"
            @click.prevent="displayFaqData(row)"
          >
            <img
              class="iconImg"
              :src="`${baseURL}/faqImage/${row.serviceIconName}`"
            />
            {{ row.serviceName }}</a
          >
          <ul
            class="dash"
            v-show-slide:300:ease-in-out="
              active1[idx] || serviceCode === row.serviceCode
            "
          >
            <li
              v-for="(user, userIndex) in row.users"
              :key="userIndex"
              :class="{ on: this.userCode === user.userCode }"
            >
              <a @click.prevent="displayFaqData(row, userIndex)">
                {{ user.userName }}
              </a>
            </li>
          </ul>
        </li>
      </ul>
      <div v-show="gbn === 1" id="content">
        <div class="faqWrap" id="menuCon">
          <div class="faqTitleSearchWrap">
            <h2 class="title">
              <span>{{ this.serviceName }}</span>
              <span>{{ this.userName }}</span>
            </h2>
            <div
              class="searchWrap"
              :style="{ display: isMobile ? 'none' : 'block' }"
            >
              <button type="button" class="btnSearch">통합검색 버튼</button>
              <form class="search" @submit.prevent="search">
                <input
                  type="text"
                  v-model="keyword"
                  placeholder="키워드를 입력하여 검색해보세요."
                />
                <button type="submit">검색</button>
              </form>
            </div>
          </div>
          <ul class="tabBtn">
            <li
              v-for="(row, idx) in type"
              :key="idx"
              :class="{ on: idx === selectTypeIdx }"
            >
              <h3>
                <button type="button" @click="getFaqData(idx, type)">
                  {{ row.typeName }}
                </button>
              </h3>
            </li>
          </ul>
          <div class="faqListWrap">
            <div id="faqList" class="con">
              <dl v-for="(row, idx) in dataList" :key="row.title">
                <transition name="fade" mode="out-in">
                  <dt
                    :ref="`scroll-${idx}`"
                    v-if="active"
                    class="tit"
                    :class="{ on: selectFaqIndex === idx }"
                    @click="getAnswerBody(idx)"
                  >
                    <span class="type">{{ row.questionTitle }}</span>
                  </dt>
                </transition>
                <dd
                  class="txt"
                  v-show-slide:500:ease="selectFaqIndex === idx"
                  v-html="row.answerBody"
                ></dd>
              </dl>
            </div>
          </div>
          <div class="listMore taC" v-show="totalCount - rows > 0">
            <button type="button" @click="getFaqList(this.rows + 10)">
              {{
                this.totalCount - this.rows >= 10
                  ? "10개 더보기"
                  : `${this.totalCount - this.rows} 개 더보기`
              }}
            </button>
            <em class="totalList">총 {{ this.totalCount }}개</em>
          </div>
        </div>
      </div>
      <div v-show="gbn === 2" id="content">
        <div class="faqWrap" id="menuCon">
          <div class="faqTitleSearchWrap">
            <h2 class="title">
              <span>검색결과</span>
              <span>전체&nbsp;{{ this.totalCount }}</span>
            </h2>
            <div
              class="searchWrap"
              :style="{ display: isMobile ? 'none' : 'block' }"
            >
              <button type="button" class="btnSearch">통합검색 버튼</button>
              <form class="search" @submit.prevent="search">
                <input
                  type="text"
                  v-model="keyword"
                  placeholder="키워드를 입력하여 검색해보세요."
                />
                <button type="submit">검색</button>
              </form>
            </div>
          </div>
          <div class="faqListWrap">
            <div id="faqList" class="con">
              <div v-show="searchDataList.length === 0" class="searchNoneCon">
                "{{ this.tempKeyword }}"에 대한 검색 결과가 없습니다.
              </div>
              <div v-for="(group, groupIdx) in searchDataList" :key="groupIdx">
                <dl v-for="(item, itemIdx) in group.items" :key="item.faqCode">
                  <transition name="fade" mode="out-in">
                    <dt
                      :ref="`scroll-${groupIdx}-${itemIdx}`"
                      v-if="active"
                      class="tit"
                      :class="{
                        on: selectFaqIndex === `${groupIdx}-${itemIdx}`,
                      }"
                      @click="getAnswerBody(`${groupIdx}-${itemIdx}`)"
                    >
                      <span class="typeName" @click="displaySearchFaqData(item)"
                        >{{ group.serviceName }}&nbsp;>&nbsp;{{
                          group.userName
                        }}</span
                      >
                      <span class="type"
                        >[{{ item.typeName }}] {{ item.questionTitle }}</span
                      >
                    </dt>
                  </transition>
                  <dd
                    class="txt"
                    v-show-slide:500:ease="
                      selectFaqIndex === `${groupIdx}-${itemIdx}`
                    "
                    v-html="item.answerBody"
                  ></dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
 <!-- 모바일 메뉴 관련 요소들 -->
  <div class="mask"></div>
  <button type="button" id="top"><span>top</span></button>
   <!-- 모바일 메뉴 영역 -->
  <div class="mobileMenuWrap">
    <div class="mobileLogo">
      <img :src="require('@/assets/images/logo.png')" alt="대구로" />
      <em>고객지원</em>
      <button type="button" class="close">모바일 메뉴 닫기</button>
    </div>
      <!-- 모바일 메뉴 리스트 -->
    <ul class="mobileMenu">
      <li v-for="(row, idx) in serviceUserData" :key="idx">
        <em :class="'tit ' + 'menuIco'">
          <img
            class="iconImg"
            :src="`${baseURL}/faqImage/${row.serviceIconName}`"
          />
          {{ row.serviceName }}</em
        >
        <ul class="dash dot">
          <li
            v-for="(user, userIndex) in row.users"
            :key="userIndex"
            :class="{ on: this.userCode === user.userCode }"
          >
            <a
              @click.prevent="
                displayFaqData(row, userIndex), removeMobileMenu()
              "
            >
              {{ user.userName }}
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  // 부모 컴포넌트로 이벤트 전달
  emits: ["move"],
  props: {
    paramServiceCode: String, // 서비스 코드
    paramUserCode: String, // 사용자 코드
  },
  data: () => ({
    isMobile: window.innerWidth <= 992,
    baseURL: "",
    keyword: "",
    tempKeyword: "",
    serviceCode: "",
    serviceName: "",
    userCode: "",
    userName: "",
    type: [],
    typeCode: "",
    serviceUserData: [],
    dataList: [],
    searchDataList: [],
    selectTypeIdx: 0,
    totalCount: 0,
    gbn: 1,
    rows: 10,
    selectFaqIndex: null,
    active: true,
    active1: {},
  }),
  mounted() {
    // 환경에 따른 baseURL 설정
    process.env.NODE_ENV === "production"
      ? (this.baseURL = "https://ext.daeguro.co.kr:45010")
      : (this.baseURL = "https://dgpub.282.co.kr:8502");
    // 이벤트 리스너 등록
    window.addEventListener("resize", this.handleResize);
    window.addEventListener("popstate", this.handlePopState);
    // 초기 데이터 로드
    this.getFaqServiceUserList();
    // 모바일 메뉴 제거 함수
    function mobileRemove() {
      $(".mobileMenuWrap").removeClass("on");
      $(".mask").removeClass("on");
    }
    // jQuery UI 이벤트 처리
    $(function () {
      // 검색 버튼 클릭 이벤트
      $(".btnSearch").click(function () {
        $(this).toggleClass("on");
        $(".search.mobile").slideToggle();
      });
      // 메뉴 버튼 클릭 이벤트
      $(".btnMenu").click(function () {
        $(this).toggleClass("on");
        $(".mobileMenuWrap").addClass("on");
        $(".mask").toggleClass("on");
      });
      // 모바일 메뉴 닫기 이벤트
      $(".mobileMenuWrap .close").click(function () {
        mobileRemove();
      });
      // 창 크기 변경 시 모바일 메뉴 처리
      $(window).on("load resize", function () {
        var w = $(window).width();
        var x = 1024;
        if (w > x) {
          mobileRemove();
        }
      });

      // TOP 버튼 클릭 이벤트
      $("#top").click(function () {
        $("html, body").stop().animate(
          {
            scrollTop: 0,
          },
          500
        );
      });
      // 스크롤 이벤트
      $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {
          $("#top").addClass("on");
        } else {
          $("#top").removeClass("on");
        }
      });
    });
  },
  methods: {
    // FAQ 서비스 및 사용자 목록 조회
    async getFaqServiceUserList(
      historyServiceCode = null,
      histroyUserCode = null
    ) {
      await this.$axios
        .get("/SupportFAQ/GetFAQService")
        .then(async (response) => {
          const filteredServices = response.data.data.filter(
            (service) => service.useGbn === "Y"
          );
          var temp = [];
          for (const item of filteredServices) {
            await this.$axios
              .get(`/SupportFAQ/GetFAQUser?serviceCode=${item.serviceCode}`)
              .then(async (response) => {
                const filteredUsers = response.data.data.filter(
                  (user) => user.useGbn === "Y"
                );
                const users = filteredUsers.map((user) => {
                  return {
                    userCode: user.userCode,
                    userName: user.userName,
                    serviceCode: user.serviceCode,
                    memo: user.memo,
                    dispSeq: user.dispSeq,
                    categoryCode: user.categoryCode,
                    useGbn: user.useGbn,
                  };
                });
                temp.push({
                  serviceCode: item.serviceCode,
                  serviceName: item.serviceName,
                  serviceIconName: item.iconName,
                  users: users,
                });
              });
          }
          this.serviceUserData = temp;
        });

      var serviceCode = this.paramServiceCode;
      var userCode = this.paramUserCode;
      if (historyServiceCode != null || histroyUserCode != null) {
        serviceCode = historyServiceCode;
        userCode = histroyUserCode;
      }
      if (serviceCode && userCode) {
        this.serviceCode = serviceCode;
        this.userCode = userCode;
        for (const item of this.serviceUserData) {
          if (item.serviceCode === serviceCode) {
            this.serviceName = item.serviceName;
            for (const user of item.users) {
              if (user.userCode === userCode) {
                this.userName = user.userName;
              }
            }
          }
        }
      } else if (serviceCode) {
        this.serviceCode = serviceCode;
        for (const item of this.serviceUserData) {
          if (item.serviceCode === serviceCode) {
            this.serviceName = item.serviceName;
            this.userCode = item.users[0].userCode;
            this.userName = item.users[0].userName;
          }
        }
      } else {
        this.serviceCode = this.serviceUserData[0].users[0].serviceCode;
        this.serviceName = this.serviceUserData[0].serviceName;
        this.userCode = this.serviceUserData[0].users[0].userCode;
        this.userName = this.serviceUserData[0].users[0].userName;
      }

      await this.getFaqTypeList(this.serviceCode, this.userCode);
    },
    // FAQ 타입 목록 조회
    async getFaqTypeList(serviceCode, userCode) {
      await this.$axios
        .get(
          `/SupportFAQ/GetFAQType?serviceCode=${serviceCode}&userCode=${userCode}`
        )
        .then(async (response) => {
          const filteredTypes = response.data.data.filter(
            (type) => type.useGbn === "Y"
          );
          this.type = filteredTypes.map((type) => {
            return {
              typeCode: type.typeCode,
              typeName: type.typeName,
              userCode: type.userCode,
              serviceCode: type.serviceCode,
              categoryCode: type.categoryCode,
              memo: type.memo,
              dispSeq: type.dispSeq,
              useGbn: type.useGbn,
            };
          });
        });
      this.typeCode = this.type[0] ? this.type[0].typeCode : 0;
      await this.getFaqList(10);
    },
    // FAQ 목록 조회
    async getFaqList(rows) {
      this.selectFaqIndex = null;
      this.dataList = null;
      this.totalCount = 0;
      await this.$axios
        .get(
          `/SupportFAQ/GetFAQSortList?useGbn=Y&serviceCode=${this.serviceCode}&userCode=${this.userCode}&typeCode=${this.typeCode}&page=1&rows=${rows}`
        )
        .then(async (response) => {
          this.totalCount = response.data.total_count;
          const filteredFaq = response.data.data.filter(
            (faq) => faq.useGbn === "Y"
          );
          this.dataList = filteredFaq.map((data) => {
            return {
              faqCode: data.faqCode,
              serviceCode: data.serviceCode,
              serviceName: data.serviceName,
              userCode: data.userCode,
              userName: data.userName,
              typeCode: data.typeCode,
              typeName: data.typeName,
              useGbn: data.useGbn,
              questionTitle: data.questionTitle,
              answerBody: data.answerBody,
              insDate: data.insDate,
              insUcode: data.insUcode,
              insUname: data.insUname,
              modDate: data.modDate,
              modUcode: data.modUcode,
              modUname: data.modUname,
            };
          });
        });
      this.rows = rows;
    },

    // FAQ 데이터 표시
    displayFaqData(serviceUserData, selectedUserIdx = 0) {
      this.gbn = 1;
      this.keyword = "";
      this.selectTypeIdx = 0;
      this.selectFaqIndex = null;
      const selectedUser = serviceUserData.users[selectedUserIdx];
      this.serviceCode = selectedUser.serviceCode;
      this.userCode = selectedUser.userCode;
      this.serviceName = serviceUserData.serviceName;
      this.userName = selectedUser.userName;

      window.history.pushState(
        {
          screen: "main",
          serviceCode: this.serviceCode,
          userCode: this.userCode,
          serviceName: this.serviceName,
          userName: this.userName,
        },
        ""
      );
      this.getFaqTypeList(this.serviceCode, selectedUser.userCode);
    },

    // FAQ 타입별 데이터 조회
    getFaqData(idx, type) {
      if (this.selectTypeIdx === idx) {
        return;
      }
      this.selectFaqIndex = null;
      this.serviceCode = type[idx].serviceCode;
      this.userCode = type[idx].userCode;
      this.typeCode = type[idx].typeCode;
      this.getFaqList(10);
      this.active = false;

      setTimeout(() => {
        this.selectTypeIdx = idx;
        this.$nextTick(() => {
          this.active = true;
        });
      }, 100);
    },
    // FAQ 답변 표시/숨김
    getAnswerBody(idx) {
      this.selectFaqIndex = this.selectFaqIndex === idx ? null : idx;
    },
    // FAQ 검색
    async search() {
      let tempTotalCount = 0;
      let tempSearchData = {};

      try {
        const faqResponse = await this.$axios.get(
          `/SupportFAQ/GetFAQ?useGbn=Y&search=${this.keyword}&div=0`
        );
        const filteredFaqs = faqResponse.data.data.filter(
          (faq) => faq.useGbn === "Y"
        );

        for (const faq of filteredFaqs) {
          const key = `${faq.serviceName}_${faq.userName}`;
          if (!tempSearchData[key]) {
            tempSearchData[key] = {
              serviceName: faq.serviceName,
              userName: faq.userName,
              items: [],
            };
          }
          tempSearchData[key].items.push(faq);
          tempTotalCount += 1;
        }

        this.selectFaqIndex = null;
        this.searchDataList = Object.values(tempSearchData);
        this.totalCount = tempTotalCount;
        this.tempKeyword = this.keyword;

        this.gbn = 2;
      } catch (error) {
        console.error("Error in search method:", error);
      }
    },
    // 검색 결과에서 FAQ 데이터 표시
    displaySearchFaqData(item) {
      this.gbn = 1;
      this.keyword = "";
      this.selectTypeIdx = 0;
      this.selectFaqIndex = null;
      this.serviceCode = item.serviceCode;
      this.userCode = item.userCode;
      this.serviceName = item.serviceName;
      this.userName = item.userName;

      this.getFaqTypeList(this.serviceCode, this.userCode);
    },
    // 홈으로 이동
    move() {
      this.$emit("move", "home");
    },
    // 메뉴 마우스 이벤트 핸들러
    handleMouseEnter(idx) {
      this.active1[idx] = true;
    },
    handleMouseLeave(idx) {
      this.active1[idx] = false;
    },
    // 화면 크기 변경 핸들러
    handleResize() {
      this.isMobile = window.innerWidth <= 992;
    },
    // 모바일 메뉴 제거
    removeMobileMenu() {
      $(".mobileMenuWrap").removeClass("on");
      $(".mask").removeClass("on");
    },
    // 브라우저 히스토리 변경 핸들러
    handlePopState(event) {
      if (event.state) {
        this.gbn = 1;
        this.keyword = "";
        this.selectTypeIdx = 0;
        this.selectFaqIndex = null;
        const { serviceCode, userCode, serviceName, userName } = event.state;
        this.serviceCode = serviceCode;
        this.userCode = userCode;
        this.serviceName = serviceName;
        this.userName = userName;
        this.getFaqServiceUserList(serviceCode, userCode);
      }
    },
  },
};
</script>
